/**
 * Peituv fototriip — mõõdab katvad sektsioonid ja annab mõõdud CSS-ile.
 *
 * MIDA EFEKT TEEB. Pilt jääb ekraani ülaserva kinni, sisuplokid libisevad
 * tema peale ja plokkide vahele jäetud vahedest tuleb ta uuesti nähtavale.
 * Katvaid plokke võib olla mitu — /teadus lehel peidab riba end kõigepealt
 * tunnustuste ploki taha, tuleb vahepeal välja, peitub siis alustalade taha
 * ja jääb lõpuks tooraine ploki alla.
 *
 * MIKS JS-I VAJA ON. Sticky element on piiratud oma vanema kastiga, seega
 * riba kast peab olema vähemalt sama kõrge kui pilt + kõik katvad sektsioonid
 * + vahed. Katvate sektsioonide kõrgus sõltub sisust ja ekraanilaiusest;
 * ükski CSS-konstant ei ole seal õige rohkem kui ühel laiusel. Sama muster ja
 * sama põhjus mis `product-thumb-align.js` — vt CLAUDE.md „Cross-column
 * measurements cannot be done in CSS here".
 *
 * ILMA JS-ITA JÄÄB TÖÖTAV LEHT: CSS kasutab `--divider-reveal-scroll`
 * vaikeväärtust (toimetaja seade), vahesid ei teki ja riba käitub nagu
 * tavaline peituv triip. Midagi ei kao.
 *
 * MÕÕDAME KATVATE SEKTSIOONIDE KÕRGUST, MITTE ENDA OMA. See on tahtlik:
 * enda kõrguse pealt oma kõrguse arvutamine on täpselt see ResizeObserver'i
 * tagasisideahel, mis CLAUDE.md-s kirjas on. Katvate sektsioonide kõrgus ei
 * sõltu riba kõrgusest, seega ahelat ei teki.
 *
 * Z-INDEX ON KOHUSTUSLIK, MITTE KOSMEETIKA. Sticky pilt on positsioneeritud
 * element ja maalitakse järgnevate STAATILISTE elementide PEALE — ilma
 * katvate sektsioonide tõstmiseta jääks pilt teksti ette, mitte taha.
 */
(() => {
  const REVEAL = '.chapter-divider--reveal';

  const setup = (band) => {
    const wrap = band.closest('.shopify-section') || band;

    // Mitu plokki riba peidab. 1 = ainult järgmine sektsioon.
    const covers = Math.max(1, parseInt(band.dataset.revealCovers || '1', 10));
    // Vahe katvate plokkide vahel ja viimase järel, vh-des.
    const gapVh = parseFloat(band.dataset.revealGap || '0') || 0;

    // Katvad sektsioonid + üks nende järel: viimane vahe jääb selle ette,
    // seega temagi peab pildi peal olema.
    const chain = [];
    let node = wrap.nextElementSibling;
    for (let i = 0; i < covers + 1 && node; i += 1) {
      chain.push(node);
      node = node.nextElementSibling;
    }
    if (!chain.length) return;

    const isWindow = band.hasAttribute('data-reveal-window');
    chain.forEach((el, i) => {
      el.style.position = 'relative';
      el.style.zIndex = '1';
      // Akna kujus hajuvad katvate plokkide servad foto sisse (CSS maskib):
      // katva ploki alaserv ja temale järgneva ploki ülaserv.
      if (isWindow) {
        if (i < covers) el.classList.add('is-reveal-cover');
        if (i > 0) el.classList.add('is-reveal-next');
      }
      // Vahe läheb iga katva ploki ETTE peale esimese: sealt paistab pilt.
      if (i > 0 && gapVh) el.style.marginTop = `${gapVh}vh`;
    });

    const coverEls = chain.slice(0, covers);

    let last = -1;
    const apply = () => {
      const kokku = coverEls.reduce((sum, el) => sum + el.getBoundingClientRect().height, 0);
      const vahed = (gapVh / 100) * window.innerHeight * covers;
      const span = Math.round(kokku + vahed);
      if (Math.abs(span - last) < 1) return;
      last = span;
      band.style.setProperty('--divider-reveal-span', `${span}px`);
    };

    apply();

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(apply);
      coverEls.forEach((el) => ro.observe(el));
    }
    // Akna KÕRGUSE muutus ei käivita ResizeObserver'it (laius ei muutu), aga
    // vahed on vh-des — seega neid tuleb eraldi kuulata.
    window.addEventListener('resize', apply, { passive: true });
  };

  const init = () => document.querySelectorAll(REVEAL).forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Teemaredaktor laob sektsiooni uuesti — siis tuleb uuesti mõõta.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();
